export default {
  computed: {
    labelsItems() {
      return [
        {
          name: 'attributes',
          dataType: { name: 'select' },
          items: this.attributes,
          translationPath: 'dialog.style.value',
          hint: 'dialog.style.chooseFields',
          multiple: true,
          'item-value': 'valueLabel',
          hasCopyAll: true,
          subProperties: ['attributes_advanced'],
        },
        {
          name: 'font-size',
          translationPath: 'dialog.style.fontSize',
          dataType: { name: 'integer' },
          rules: this.getMinMaxRules(1, 40, true),
        },
        { name: 'font-color', dataType: { name: 'color' }, translationPath: 'dialog.style.fontColor' },
        {
          name: 'font-weight',
          dataType: { name: 'select' },
          items: this.fontWeightItems,
          translationPath: 'dialog.style.fontWeight',
          rules: this.getRequiredRules(true),
          autoConvertSelect: false,
        },
        {
          name: 'zoom',
          subProperties: ['minzoom', 'maxzoom'],
          translationPath: 'dialog.style.zoom',
          dataType: { name: 'integer' },
          rules: this.getMinMaxRules(1, 28, true, true),
          allowNegative: false,
        },
        {
          name: 'offset-x',
          translationPath: 'dialog.style.offsetX',
          dataType: { name: 'integer' },
          rules: this.getMinMaxRules(-101, 100, true),
        },
        {
          name: 'offset-y',
          translationPath: 'dialog.style.offsetY',
          dataType: { name: 'integer' },
          rules: this.getMinMaxRules(-100, 100, true),
        },
        {
          name: 'stroke-visible',
          translationPath: 'dialog.style.strokeVisible',
          label: this.$i18n.t('dialog.style.strokeVisible'),
          dataType: { name: 'checkbox' },
          hideTitleCol: true,
          hideDetails: true,
        },
        {
          name: 'stroke-width',
          translationPath: 'dialog.style.strokeSize',
          dataType: { name: 'integer' },
          rules: this.computedLabelsStyle['stroke-visible'] ? this.getMinMaxRules(1, 20, true) : [],
          disabled: !this.computedLabelsStyle['stroke-visible'],
          titleClasses: this.computedLabelsStyle['stroke-visible'] ? [] : ['text--disabled'],
        },
        {
          name: 'stroke-color',
          dataType: { name: 'color' },
          translationPath: 'dialog.style.strokeColor',
          disabled: !this.computedLabelsStyle['stroke-visible'],
          titleClasses: this.computedLabelsStyle['stroke-visible'] ? [] : ['text--disabled'],
        },
      ];
    },
    styleItems() {
      return {
        linestring: [
          {
            name: 'line-dash',
            dataType: { name: 'select' },
            items: this.strokeKinds,
            translationPath: 'dialog.style.lineStyle',
            hasCopyAll: true,
          },
          { name: 'line-color', dataType: { name: 'color' }, translationPath: 'dialog.style.color' },
          {
            name: 'fill-opacity',
            translationPath: 'dialog.style.transparency',
            dataType: { name: 'slider' },
            inputCols: 5,
            step: '0.01',
            min: '0',
            max: '1',
            isPercentageLabel: true,
          },
          {
            name: 'line-width',
            translationPath: 'dialog.style.lineWidth',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 20),
          },
          {
            name: 'zoom',
            subProperties: ['minzoom', 'maxzoom'],
            translationPath: 'dialog.style.zoom',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 28, false, true),
            allowNegative: false,
          },
        ],
        point: [
          this.symbolizationKind === 'point'
            ? {
                name: 'circle-color',
                translationPath: 'dialog.style.color',
                dataType: { name: 'color' },
                hasCopyAll: true,
              }
            : { name: 'externalGraphic', translationPath: 'dialog.style.iconsList', hasCopyAll: true },
          this.symbolizationKind === 'point'
            ? {
                name: 'circle-radius',
                translationPath: 'dialog.style.pointSize',
                dataType: { name: 'integer' },
                rules: this.getMinMaxRules(1, 40),
              }
            : {
                name: 'icon-size',
                translationPath: 'dialog.style.iconSize',
                dataType: { name: 'decimal', decimal_places: 1 },
                rules: this.getMinMaxRules(0, 5),
              },
          {
            name: 'fill-opacity',
            translationPath: 'dialog.style.transparency',
            dataType: { name: 'slider' },
            inputCols: 5,
            step: '0.01',
            min: '0',
            max: '1',
            isPercentageLabel: true,
          },
          {
            name: 'zoom',
            subProperties: ['minzoom', 'maxzoom'],
            translationPath: 'dialog.style.zoom',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 28, false, true),
            allowNegative: false,
          },
        ],
        polygon: [
          {
            name: 'line-dash',
            dataType: { name: 'select' },
            items: this.strokeKinds,
            translationPath: 'dialog.style.stroke',
            hasCopyAll: true,
          },
          ...(this.symbolizationKind === 'polygon'
            ? [{ name: 'fill-color', dataType: { name: 'color' }, translationPath: 'dialog.style.fillColor' }]
            : [
                { name: 'externalGraphic', translationPath: 'dialog.style.iconsList' },
                // {
                //   name: 'icon-size',
                //   translationPath: 'dialog.style.iconSize',
                //   dataType: { name: 'decimal', decimal_places: 1 },
                //   rules: this.getMinMaxRules(0, 5),
                // },
              ]),
          {
            name: 'fill-opacity',
            translationPath: 'dialog.style.fillTransparency',
            dataType: { name: 'slider' },
            inputCols: 5,
            step: '0.01',
            min: '0',
            max: '1',
            isPercentageLabel: true,
          },
          { name: 'fill-outline-color', dataType: { name: 'color' }, translationPath: 'dialog.style.strokeColor' },
          {
            name: 'fill-outline-opacity',
            translationPath: 'dialog.style.strokeTransparency',
            dataType: { name: 'slider' },
            inputCols: 5,
            step: '0.01',
            min: '0',
            max: '1',
            isPercentageLabel: true,
          },
          {
            name: 'line-width',
            translationPath: 'dialog.style.strokeWidth',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 20),
          },
          {
            name: 'zoom',
            subProperties: ['minzoom', 'maxzoom'],
            translationPath: 'dialog.style.zoom',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 28, false, true),
            allowNegative: false,
          },
        ],
        service: [
          {
            name: 'zoom',
            subProperties: ['minzoom', 'maxzoom'],
            titleCols: 6,
            inputCols: 6,
            clearable: true,
            translationPath: 'dialog.style.zoom',
            dataType: { name: 'integer' },
            rules: this.getMinMaxRules(1, 28, false, true),
            allowNegative: false,
          },
        ],
      };
    },
    fontWeightItems() {
      return [
        { value: 'bold', text: this.$i18n.t('dialog.style.fontWeightBold') },
        { value: 'normal', text: this.$i18n.t('dialog.style.fontWeightNormal') },
      ];
    },
    strokeKinds() {
      return [
        { value: [], text: this.$i18n.t('dialog.style.line') },
        { value: [10, 40], text: this.$i18n.t('dialog.style.dashed') },
        { value: [10, 10], text: this.$i18n.t('dialog.style.dashed-dense') },
        { value: [10, 1, 10], text: this.$i18n.t('dialog.style.dashed-dotted') },
        { value: [1, 5], text: this.$i18n.t('dialog.style.dotted') },
      ];
    },
  },
  methods: {
    getMinMaxRules(min, max, isLabel = false, canBeEmpty = false) {
      const rules = [
        v =>
          (canBeEmpty && (v === null || v === undefined || v === '')) ||
          v <= max ||
          this.$i18n.t('rules.maxValue', { value: max }),
      ];
      rules.push(
        min == '0'
          ? v =>
              (canBeEmpty && (v === null || v === undefined || v === '')) ||
              v > min ||
              this.$i18n.t('rules.minValueGreaterThan0')
          : v =>
              (canBeEmpty && (v === null || v === undefined || v === '')) ||
              v >= min ||
              this.$i18n.t('rules.minValue', { value: min })
      );
      if (isLabel) {
        if (this.computedLabelsStyle.attributes && this.computedLabelsStyle.attributes.length > 0 && !canBeEmpty) {
          rules.unshift(v => !!v || v == 0 || this.$i18n.t('rules.required'));
        } else {
          return [];
        }
      }
      return rules;
    },
    getRequiredRules(isLabel) {
      const rules = [v => !!v || v == 0 || this.$i18n.t('rules.required')];
      if (isLabel && (!this.computedLabelsStyle.attributes || this.computedLabelsStyle.attributes.length === 0)) {
        return [];
      }
      return rules;
    },
  },
};
